import { SagaIterator } from 'redux-saga';
import { all, call, put, select, takeLatest } from 'redux-saga/effects';

import * as errorHandlerActions from '@/components/errorHandler/Actions';
import * as reportActions from '@/pages/report/Actions';
import * as exerciseActions from '@/playlist/Actions';
import { reportActionTypes } from '@/pages/report/Constants';
import { getExerciseApiPath } from '@/services/Constants';
import { getPlayListSections } from '@/pages/report/Selectors';
import { processRequest } from '@/services/Api';

import type { PlaylistSection } from '@/pages/report/types';

export default function* (): SagaIterator {
	yield all([
		yield takeLatest(
			reportActionTypes.GET_PLAYLIST_SECTION_REPORT_REQUEST,
			handlePlaylistSectionReportRequest,
		),
	]);
}

export function* handlePlaylistSectionReportRequest({ payload }: any): SagaIterator {
	const { id } = payload || {};
	const playListSections: Record<string, PlaylistSection> = yield select(getPlayListSections);

	if (playListSections[id]) {
		yield put(reportActions.getPlaylistSectionReportSuccess(playListSections[id]));
		return;
	}

	try {
		const { data } = yield call(processRequest, getExerciseApiPath(id), 'GET', {
			preview: true,
		});

		yield put(reportActions.getPlaylistSectionReportSuccess(data?.user_learning_path_section));
		yield put(
			exerciseActions.getQuestionsExplanations({
				questionIds: data.user_learning_path_section.questions.map(
					(question: any) => question.id,
				),
			}),
		);
	} catch (e) {
		yield put(reportActions.getPlaylistSectionReportError(e));
		yield put(errorHandlerActions.handleError(e));
	}
}
